import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalService } from "ngx-bootstrap";
import { BsModalRef } from "ngx-bootstrap";
import '@fullcalendar/core/vdom';
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { CommentService } from "./../../common/comments/comment.service";
import { UserView } from "app/+admin/+users/users.service";
import {
  CommentView,
  TicketReschedule,
  TicketUpdateRequest,
} from "./../ticket.service";
import { TicketService, TicketView } from "app/+tickets/ticket.service";
import {
  AfterContentInit,
  AfterViewInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { createEventId, INITIAL_EVENTS } from "./event-utils";
import {
  CalendarOptions,
  EventApi,
  DateSelectArg,
  EventClickArg,
  FullCalendarComponent,
  EventChangeArg,
} from "@fullcalendar/angular";
import { Component, OnInit } from "@angular/core";

import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import "bootstrap/dist/css/bootstrap.css";

import esLocale from "@fullcalendar/core/locales/es";

@Component({
  selector: "app-agenda-ventas",
  templateUrl: "./agenda-ventas.component.html",
  styleUrls: ["./agenda-ventas.component.css"],
})
export class AgendaVentasComponent
  implements OnInit, AfterViewInit
{
  
  ticket: TicketView = new TicketView();
  @ViewChild("popOverUsersAssigned") private modalAssigned: TemplateRef<any>;
  bsModalAssigned: BsModalRef;
  calendarApi;
  
  updateRequest: TicketUpdateRequest = new TicketUpdateRequest();
  BotonbloqueadoGuardar: boolean = true;
  BotonbloqueadoCancelar: boolean = true;
  btnAgregarInstalacion: boolean = true;
  reschedule: TicketReschedule = new TicketReschedule();
  diaTitulo: any;
  fechaTitulo: any;
  eventoCalendario:any;
  scheduledDate: any;
  MostrarCalendar: boolean = true;
  eventoFechas = [];
  currentEvents = [];
  nowIndicator: true;
  nombreDelDiaSegunFecha: any;
  horaSeleccionada: any;
  fechaparametro: any;
  horaparametro: any;
  evento: any;
  idTicketInstalacion: any;
  bloquearAnterior: boolean = false;
  horaActual = new Date();
  horaTitulo = new Date();
  @ViewChild("calendar") calendarComponent: FullCalendarComponent;
  private infoUserLogged: UserView = new UserView();
  horaEvaluar2 = new Date();
  ValidacionUnClick: boolean = false;
  btnAgregar;
  calendarVisible = true;

  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: "",
      center: "",
      right: "",
    },
    initialView: "timeGridDay",
  
    weekends: true,
    editable: false,
    selectable: true,
    plugins: [dayGridPlugin, interactionPlugin],
     locale: esLocale,
    selectMirror: false,
    // slotDuration: '00:15:00',
    slotLabelInterval: 30,
   // slotLabelFormat: 'h(:mm)a',
   slotLabelFormat: (verboseFormatting) => {
    if(verboseFormatting.date.hour == 9 && verboseFormatting.date.minute == 0){
        return "Mañana";
    }
    if(verboseFormatting.date.hour == 13  && verboseFormatting.date.minute == 0){
        return "Mediodía";
    }
    if(verboseFormatting.date.hour == 16  && verboseFormatting.date.minute == 0){
        return "Tarde";
    }
    // if (verboseFormatting.date.minute == 0) {
    //     verboseFormatting.date.minute = verboseFormatting.date.minute + "0";
    // }
    // return (verboseFormatting.date.hour % 12 ? verboseFormatting.date.hour % 12 : "12") + (verboseFormatting.date.hour < 12 ? ":" + verboseFormatting.date.minute + " " : ":" + verboseFormatting.date.minute + " ")
},
    dayMaxEvents: true,
    slotMinTime: "08:00 ",
    slotMaxTime: "20:00 ",
    businessHours: {
      startTime: "8:00",
      endTime: "20:00",
    },
    contentHeight: "auto",
    select: this.handleDateSelect.bind(this),
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this),
    eventChange: this.eventChange.bind(this),
    droppable: true,
    events: this.eventoFechas,
    customButtons: {
      addEventButton: {
        text: "+",
        click: this.ocultarCalendario.bind(this),
      },
    },
  };
  viewingMode: string = "cards";


  constructor(
    private ticketService: TicketService,
    private commentService: CommentService,
    public bsModalRef: BsModalRef,
    private bsModalService: BsModalService,
    private notificationService: NotificationService
  ) {
    this.nombreDelDiaSegunFecha = (fecha) => {
      return [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ][new Date(fecha).getDay()];
    };
    console.log(this.nombreDelDiaSegunFecha(new Date()));
  }
  ngOnInit() {
    console.log(this.ticket, this.idTicketInstalacion);

    // let datos = {
    //   idTicket: this.ticket.idTicket,
    //   date: new Date().getTime(),
    // };

    // this.ticketService.agendaticket(datos).subscribe((res) => {
    //   console.log(res,'jhjhv');

    //   for(let i=0; i<res.length;i++){

    //     let evento={
    //       title: 'Fecha Agendada',
    //       start:new Date( res[i].startDate),
    //       end:  new Date( res[i].endDate),

    //       allDay: false,
    //     }
    //     this.eventoFechas.push(evento);
    //   }
    //   console.log('ev final',this.eventoFechas);
    //   this.calendarComponent.getApi().render();

    //   this.someMethod();

    // });

    this.infoUserLogged = JSON.parse(localStorage.getItem("info_user_logged"));
  }

  ngAfterViewInit() {
    window.dispatchEvent(new Event("resize"));
    this.calendarApi = this.calendarComponent.getApi();
    
    if (this.nombreDelDiaSegunFecha(new Date()) == "miércoles" ||
      this.nombreDelDiaSegunFecha(new Date()) == "jueves" ||
      this.nombreDelDiaSegunFecha(new Date()) == "viernes" ) {
      for(let i=0;i<5;i++){
        this.calendarComponent.getApi().next();
      }
     this.horaEvaluar2.setDate(this.horaTitulo.getDate() + 5);
    } else {
      for(let i=0;i<3;i++){
        this.calendarComponent.getApi().next();
      }
      this.horaEvaluar2.setDate(this.horaTitulo.getDate() + 3);
    }
    const currentDate = this.calendarApi.view.currentStart;
     console.log(currentDate);
    this.someMethod(true);
  }
  
  someMethod(BuscareVentos?: boolean) {
    this.eventoFechas.length=0;
    const calendarApi = this.calendarComponent.getApi();
    const currentDate = calendarApi.view.currentStart;
    const actuale = calendarApi.view;
     let fechaHoy = this.horaEvaluar2;
    if (currentDate.getDate() <= fechaHoy.getDate() || currentDate.getDate() === fechaHoy.getDate()) {
       this.bloquearAnterior = false;
    } else {
      this.bloquearAnterior = true;
    }
  this.diaTitulo = new Date(currentDate).toLocaleDateString("es-MX", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    if (BuscareVentos == true) {
      let datos = {
        idTicket: this.idTicketInstalacion,
        date: new Date(currentDate).getTime(),
      };

      this.ticketService.agendaticket(datos).subscribe((res) => {
        for (let i = 0; i < res.length; i++) {
          let evento = {
            title: "Fecha Agendada",
            start: new Date(res[i].startDate),
            end: new Date(res[i].endDate),
            allDay: false,
          };
          this.eventoFechas.push(evento);
        }
        if(this.eventoCalendario){
          this.eventoFechas.push(this.eventoCalendario);
        }
        console.log("eventos", this.eventoFechas);
        this.calendarComponent.getApi().render();
      });
    }
  }
  handleDateSelect(selectInfo?: DateSelectArg, aceptado?: boolean) {
    console.log("selectInfo", selectInfo, aceptado);
    const fechaFinal = selectInfo.startStr;
      const PrimeraHora = selectInfo.startStr;
      let fechadeFin = new Date(fechaFinal);
      let fecha45 = fechadeFin.setMinutes(fechadeFin.getMinutes() + 45);
           
         this.eventoCalendario = {
          title: "Venta",
          start: PrimeraHora,
          end: new Date(fecha45),
          allDay: false,
        };
  
        this.evento = {
          title: "Venta",
          startTime:new Date(PrimeraHora) ,
          endTime: new Date(fecha45),
          desc: "instalacion agendada",
          allDay: false,
        };
        this.horaparametro = new Date(PrimeraHora);
        this.fechaparametro = new Date(PrimeraHora).toLocaleDateString(
          "es-MX",
          { weekday: "long", day: "numeric", month: "long", year: "numeric" }
        );
        this.scheduledDate = new Date(PrimeraHora).getTime();

    if (this.ValidacionUnClick == false) {
       this.eventoFechas.push(this.eventoCalendario);
       this.BotonbloqueadoGuardar = false;
       this.ValidacionUnClick = true;
      
    }else{
      this.eventoFechas.pop();
      this.eventoFechas.push(this.eventoCalendario);
        
    }
  }

  onClickNext() {
    this.calendarComponent.getApi().next();
    this.someMethod(true);
  }
  onClickPrev() {
    this.calendarComponent.getApi().prev();
    this.someMethod(true);
  }

  Guardar() {
    console.log("guardar",this.evento,this.reschedule);
    this.reschedule.idTicket = this.idTicketInstalacion;
    this.reschedule.scheduledDate = this.scheduledDate;
    this.ticketService.reschedule(this.reschedule).subscribe(() => {
      this.notificationService.bigBox({
        title: 'Instalacion Agendada',
        content: 'La Instalacion se Agendó Exitosamente: </br><b></b>',
        color: '#739E73',
        icon: 'fa fa-check',
        timeout: 8000
    });
      this.AgregarComentario(this.fechaparametro, this.horaparametro);

      let addOrUpdateVisitsExtraInfoList = [this.evento];
      const indexExtraInfo: number = this.ticket.extraInfoList.findIndex(
        (info) => info.key.toLowerCase() === "agendado".toLowerCase()
      );
      
      if (indexExtraInfo >= 0) {
        this.ticket.extraInfoList[indexExtraInfo].value.push(this.evento);
      } else {
        this.ticket.extraInfoList.push({
          key: "agendado",
          legend: "agendado",
          value: addOrUpdateVisitsExtraInfoList,
        });
      }
      console.log("ticket final", this.ticket);

      this.updateRequest.extraInfoList = this.ticket.extraInfoList;
      this.updateRequest.idPriority = this.ticket.idPriority;
      this.ticketService.updateTicket(this.updateRequest, this.ticket.idTicket)
        .subscribe(() => {
          this.cerrarModal();
        });
    }, (error) => {
      console.error(error);
      
  });
  }

  AgregarComentario(fechaparametro: any, horaparametro: any) {
    let commentFE: CommentView = new CommentView();
    commentFE.comment =
      "Se agendo una instalacion, con Fecha: " +
      fechaparametro +
      " " +
      new Date(horaparametro).toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    commentFE.commentDate = new Date().getTime();
    commentFE.commentName = this.infoUserLogged.userAppView.name;
    commentFE.commentUsername = this.infoUserLogged.userAppView.username;
    commentFE.commentVisibility = "public";
    commentFE.attachments = null;
    commentFE.attachments = [];
    this.commentService.addTicketComment(this.ticket.idTicket, commentFE)
      .subscribe((res) => {
        console.log(res);
        this.commentService.getTicketComments(this.ticket.idTicket);
      });
  }

  cerrarModal() {
     this.bsModalRef.hide();
  }
  
  ocultarCalendario(event?: MouseEvent): void {
    // this.MostrarCalendar=false;

    if (event) {
      event.stopPropagation();
    }

    this.bsModalAssigned = this.bsModalService.show(this.modalAssigned, {
      class: "modal-sm modal-assigned",
    });
    try {
      const bsModal: Element =
        document.getElementsByClassName("modal-assigned")[0];
      if (event) {
        const bsModalHTML: HTMLElement = bsModal as HTMLElement;
        bsModalHTML.style.margin = "0";
        if (window.innerHeight < event.y + bsModalHTML.offsetHeight) {
          bsModalHTML.style.top = event.y - bsModalHTML.offsetHeight + "px";
        } else {
          bsModalHTML.style.top = event.y + "px";
        }
        if (this.viewingMode === "cards") {
          bsModalHTML.style.left = event.x + "px";
        } else {
          bsModalHTML.style.left = event.x - bsModalHTML.offsetWidth + "px";
        }
        if (window.outerWidth < event.x + bsModalHTML.offsetWidth) {
          bsModalHTML.style.left = event.x - bsModalHTML.offsetWidth + "px";
        } else {
          bsModalHTML.style.left = event.x + "px";
        }
      }
      const bsModalBackdrop: Element =
        bsModal.parentElement.previousElementSibling;
      if (bsModalBackdrop.nodeName.toLowerCase() === "bs-modal-backdrop") {
        bsModalBackdrop.classList.add("bs-modal-backdrop-white");
      }
    } catch (e) {}
  }

  handleCalendarToggle() {
    this.calendarVisible = !this.calendarVisible;

    this.bsModalAssigned = this.bsModalService.show(this.modalAssigned, {
      class: "modal-sm modal-assigned",
    });
    try {
      const bsModal: Element =
        document.getElementsByClassName("modal-assigned")[0];

      const bsModalBackdrop: Element =
        bsModal.parentElement.previousElementSibling;
      if (bsModalBackdrop.nodeName.toLowerCase() === "bs-modal-backdrop") {
        bsModalBackdrop.classList.add("bs-modal-backdrop-white");
      }
    } catch (e) {}
  }

  handleWeekendsToggle() {
    const { calendarOptions } = this;
    calendarOptions.weekends = !calendarOptions.weekends;
  }

  

  

  handleEventClick(clickInfo: EventClickArg) {
    // if (
    //   confirm(
    //     `Are you sure you want to delete the event '${clickInfo.event.title}'`
    //   )
    // ) {
    //   clickInfo.event.remove();
    // }
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

 
  
  

  eventChange(arg: EventChangeArg) {
    console.log(arg);
  }

  

 
  
  Aceptar() {
    console.log(this.horaSeleccionada);
    if (this.horaSeleccionada) {
      const fechaseleccionada = new Date(this.fechaTitulo)
        .toISOString()
        .slice(0, 10);
      const PrimeraHora = new Date(
        `${fechaseleccionada}T${this.horaSeleccionada}`
      );
      const fechaFinal = new Date(
        `${fechaseleccionada}T${this.horaSeleccionada}`
      );

      let fechadeFin = fechaFinal;
      let fecha45 = fechadeFin.setMinutes(fechadeFin.getMinutes() + 45);

      console.log(
        fechaseleccionada,
        "hora mas dia ",
        PrimeraHora,
        "++++++",
        new Date(fecha45)
      );
      this.horaparametro = new Date(PrimeraHora);
      this.fechaparametro = new Date(PrimeraHora).toLocaleDateString("es-MX", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      this.evento = {
        title: "Venta",
        startTime: PrimeraHora,
        endTime: new Date(fecha45),
        desc: "instalacion agendada",
        allDay: false,
      };

      this.BotonbloqueadoGuardar = false;
      this.MostrarCalendar = true;
      this.btnAgregarInstalacion = false;

      let eventoCalendario = {
        title: "Venta",
        start: PrimeraHora,
        end: new Date(fecha45),

        allDay: false,
      };

      this.eventoFechas.push(eventoCalendario);

      console.log(this.eventoFechas);
      this.bsModalAssigned.hide();

    }
  }

 
}
